import Main from "./Main";
import Form from "./Form";



export default { Main, Form }